import VPopover from './VPopover.vue';

export { VPopover };
export default VPopover;
